import type {RouteRecordRaw} from "vue-router";
import {canAccess, permissionList} from "@/utilities/authorization.ts";

const userLogRoutes: RouteRecordRaw[] = [
  {
    name: 'user-log',
    path: '/user-log',
    component: () => import('@/views/user-log/UserLogIndex.vue'),
    beforeEnter: () => canAccess(permissionList.READ_USER_LOG) ? true : { name: 'user-navigation' },
  },
  {
    name: 'user-log-detail',
    path: '/user-log/:id(\\d+)',
    component: () => import('@/views/user-log/UserLogDetail.vue'),
    beforeEnter: () => canAccess(permissionList.READ_USER_LOG) ? true : { name: 'user-navigation' },
  },
]

export default userLogRoutes